module.exports = __webpack_public_path__ + "static/media/setup-approval.ff4bf6d9.svg";